import React from "react";

interface MindMapFrameProps {
  children: React.ReactNode;
}

export const MindMapFrame: React.FC<MindMapFrameProps> = ({ children }) => {
  return (
    <div className="my-4 overflow-hidden rounded-xl border border-border/60 bg-card shadow-sm">
      {children}
    </div>
  );
};
